<template lang="pug">
v-card.rounded-lg.elevation-25.responsive()

    .canvas(ref="canvasBox" )
        .image(:style="{ backgroundImage: 'url(' + displayThumbnail(clip) + ')', width: windowSize.width + 'px', height: windowSize.height + 'px' }")
        //-.overlayItems(v-if="windowSize.width > 0 && layerItems.length > 0" v-for="layerItem in layerItems")
          h2 {{layerItem.id}}
        .overlays(v-if="windowSize.width > 0" v-for="(layer, index) in layerItems" :key="index" :style="{ width: windowSize.width + 'px', height: windowSize.height + 'px' }")
          div.scaleIframe(v-html="`${getHtml(layer)}`" :style="getScaling()" )

    </template>

<script>
import urlFormat from "@/utils/urlFormat";
import { mapState } from "vuex";

export default {
  name: "PreviewCanvas",
  props: ["clip", "layerItems"],
  data: () => ({
    windowSize: {
      height: 100,
      width: 200,
    },
  }),
  watch: {
    $props: {
      handler() {
        this.matchHeight();
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    this.matchHeight();
    window.addEventListener("resize", this.matchHeight);
  },
  destroyed() {
    window.removeEventListener("resize", this.matchHeight);
  },

  mounted() {
    setTimeout(() => this.matchHeight());
  },
  computed: {
    ...mapState({
      selectedTheme: (state) => state.create.selectedTheme,
    }),
  },
  methods: {
    ...urlFormat,

    getHtml(layerItem) {
      if (!layerItem) return "";
      if (!layerItem.htmlTemplate) return "";

      const { params, htmlTemplate, fontBase64 } = layerItem;

      if (
        params
          .filter((param) => !param.key.startsWith("BRANDING_"))
          .every((param) => !param.value || param.value === "")
      ) {
        return "";
      }

      // Quick fix to use theme colors instead of branding colors
      const { primaryColor, accentColor } = this.selectedTheme;
      if (primaryColor) {
        const i = params.findIndex(
          (param) => param.key === "BRANDING_PRIMARY_COLOR"
        );
        if (i > -1) params[i].value = primaryColor;
      }

      if (accentColor) {
        const i = params.findIndex(
          (param) => param.key === "BRANDING_ACCENT_COLOR"
        );
        if (i > -1) params[i].value = accentColor;
      }

      let html = htmlTemplate;

      const templateOverwritingParam = params.find(
        (param) => param.overwriteTemplate
      );

      if (templateOverwritingParam) {
        html =
          templateOverwritingParam.templates[templateOverwritingParam.value];
      }

      params.forEach(
        (param) =>
          (html = this.setTemplateParam(
            html,
            param.key,
            param.value ?? param.defaultValue
          ))
      );
      html = this.setTemplateParam(
        html,
        "BRANDING_FONT_BASE64",
        fontBase64 ?? this.selectedTheme.fontBase64
      );
      html = this.setTemplateParam(
        html,
        "LOGO_LIGHT",
        this.selectedTheme.logoLightUrl
      );

      html = this.setTemplateParam(
        html,
        "LOGO_DARK",
        this.selectedTheme.logoDarkUrl
      );
      return html;
    },
    setTemplateParam(str, find, replace) {
      const key = "{" + find + "}";
      return str.replace(new RegExp(key, "g"), replace ?? "");
    },

    getScaling() {
      let scaleWide = 0.3578125;
      const chosenWidth = 1920;
      const chosenHeight = 1080;
      if (this.windowSize.width > 0) {
        scaleWide = this.windowSize.width / chosenWidth;
      }

      // const scaleWide = 0.3578125;
      return `
      width: ${chosenWidth}px;
      height: ${chosenHeight}px;
      transform: scale(${scaleWide});
      -webkit-transform: scale(${scaleWide});
      -moz-transform: scale(${scaleWide});
      -o-transform: scale(${scaleWide});
      transform: scale(${scaleWide});`;
    },
    matchHeight() {
      const canvasBox = this.$refs.canvasBox;

      if (!canvasBox) return;

      const width = canvasBox.clientWidth;
      const height = canvasBox.clientHeight;
      // console.log({ canvasBox, height, width });
      this.windowSize.height = height;
      this.windowSize.width = width;
      // this.setSrcOfIframe();
    },

    displayThumbnail(item) {
      const src = this.getThumbnailUrl(item.id, item.token, item.element);
      return src;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/style/variables";

.scaleIframe {
  width: 1920px;
  height: 1080px;
  transition: all 0.3 ease;
  transform-origin: left bottom;
  -webkit-transform-origin: left bottom;
  -moz-transform-origin: left bottom;
}
.responsive {
  width: 100%;
  aspect-ratio: 16 / 9;
  overflow: hidden;
}
.canvas {
  width: 100%;
  aspect-ratio: 16 / 9;
  background: $light;
  overflow: hidden;
  box-shadow: $box-shadow;
  .image {
    width: 100%;
    height: 100%;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
  }
  .overlays {
    position: absolute;
    top: 0;
    bottom: 0;
    /* background: red; */
    /* z-index: 10; */
    /* opacity: 0.5; */
    display: flex;
    justify-content: flex-start;
    align-items: flex-end;
  }
}
</style>
